<template>
    <div class="page" style="max-width: 700px">
        <template v-if="hasRole(Roles.dealer_principle)">
            <div class="row">
                <div class="col-sm-12">
                    <div class="page-title-box">
                        <h4 class="page-title" id="page_title">Settings</h4>
                    </div>
                </div>
            </div>
            <div class="card card-body m-0">
                <div class="form-group row">
                    <label class="col-sm-6 col-form-label">Set the duration for putting a vehicle on hold:</label>
                    <div class="col-sm-6">
                        <select :class="{ 'parsley-error' : form.errors.has('hold_duration') }"
                                class="form-control"
                                title="Hold duration"
                                v-model="form.hold_duration">
                            <option :value="null" disabled>Set duration</option>
                            <option :value="24">24 hrs</option>
                            <option :value="48">48 hrs</option>
                        </select>
                        <ul :class="{'filled' : form.errors.has('hold_duration')}"
                            class="parsley-errors-list">
                            <li class="parsley-required">
                                {{ form.errors.get('hold_duration') }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-6 col-form-label">Set the duration for putting a vehicle under offer:</label>
                    <div class="col-sm-6">
                        <select :class="{ 'parsley-error' : form.errors.has('offer_duration') }"
                                class="form-control"
                                title="Offer duration"
                                v-model="form.offer_duration">
                            <option :value="null" disabled>Set duration</option>
                            <option :value="24">24 hrs</option>
                            <option :value="48">48 hrs</option>
                        </select>
                        <ul :class="{'filled' : form.errors.has('offer_duration')}"
                            class="parsley-errors-list">
                            <li class="parsley-required">
                                {{ form.errors.get('offer_duration') }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="text-center mt-3">
                    <button :disabled="form.busy"
                            @click="submit()"
                            class="btn btn-primary waves-effect waves-light"
                            type="button">
                        <i class="mdi mdi-content-save"/>
                        Save changes
                    </button>
                </div>
            </div>
        </template>

        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title">Import Vehicles</h4>
                </div>
            </div>
        </div>
        <div class="card m-b-20">
            <div class="card-body">
                <div class="mt-40">
                    <button @click="$refs.file.click()"
                            class="btn btn-primary waves-effect waves-light"
                            type="button">
                        <i class="mdi mdi-file-delimited"/>
                        Select Csv File
                    </button>
                    <input @change="onChangeFile" accept=".csv" ref="file" style="display: none"
                           type="file"/>
                    <button :disabled="import_vehicle_form.busy"
                            v-if="import_vehicle_form.file"
                            :loading="import_vehicle_form.busy"
                            @click="submitVehicles()"
                            class="btn btn-primary waves-effect waves-light"
                            type="button">
                        <i class="mdi mdi-content-save"/>
                        Upload Now
                    </button>
                    <p class="mt-2 mb-0" v-if="import_vehicle_form.file">
                        Selected file: <b>{{ import_vehicle_form.file.name }}</b>
                    </p>
                    <p class="m-0 mt-4" style="text-decoration: underline;">
                        <a href="/templates/vehicle-import.csv">Download Template</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Actions from "@/constants/store/actions";
    import User from "@/models/user";
    import Roles from "@/constants/roles";

    export default {
        data() {
            return {
                Roles,
                setting: null,
                form: new Form({
                    hold_duration: null,
                    offer_duration: null,
                }, {
                    hold_duration: 'required|integer|in:24,48',
                    offer_duration: 'required|integer|in:24,48',
                }),
                import_vehicle_form: new Form({
                    file: null
                }, {
                    file: 'required',
                }),
                users: [],
            }
        },
        created() {
            this.getUsers();
        },
        mounted() {
            let company = this.$store.state.user.companies[0];
            this.form = _.extend(this.form, _.pick(company, [
                'hold_duration',
                'offer_duration',
            ]))
        },
        methods: {
            submit() {
                this.form.validate()
                    .then(() => {
                        this.$confirm('Are you sure to save changes?', 'Confirm', {
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Cancel',
                            type: 'info'
                        }).then(() => {
                            App.put(`/web-api/setting`, this.form)
                                .then(() => {
                                    this.$notify.success({
                                        title: 'Success',
                                        message: 'Settings have been saved.',
                                    });
                                    this.$store.dispatch(Actions.refresh_auth_user);
                                });
                        });
                    });
            },
            getUsers() {
                User.params({
                    no_pagination: 1
                })
                    .include('roles')
                    .get()
                    .then(response => {
                        this.users = response;
                    })
            },
            onChangeFile(e) {
                if (e.target.files.length) {
                    this.import_vehicle_form.file = e.target.files[0];
                } else {
                    this.import_vehicle_form.file = null;
                }
            },
            submitVehicles() {
                this.import_vehicle_form.validate()
                    .then(() => {
                        this.$confirm('Are you sure you want to import file?', 'Confirm', {
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'Cancel',
                            type: 'info'
                        }).then(() => {
                            App.postData(`/web-api/vehicle/import`, this.import_vehicle_form)
                                .then(() => {
                                    this.import_vehicle_form.clearFields();
                                    $(this.$refs.file).val('');
                                    this.$notify.info({
                                        message: 'Your import is still being processed. We\'ll notify you through email once it\'s done.',
                                    });
                                });
                        });
                    });
            }
        }
    }
</script>

<style scoped>

</style>
